import {
  Image,
  type ImageProps
} from '@chakra-ui/react';

export type UiImageProps = ImageProps;

export const UiImage = Image;
